// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"4e893838","239":"21eb5769","726":"2efc1f8a","732":"fad4139a","775":"5745593a","795":"044ff09e","833":"e953ce97","977":"236a6628"}[chunkId] + ".chunk.js";
};